import { render, staticRenderFns } from "./customerActions.vue?vue&type=template&id=05aa65ea&"
import script from "./customerActions.vue?vue&type=script&lang=js&"
export * from "./customerActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports